module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"window":"Raamkozijnen","door":"Deurkozijnen","both":"Allebei"}}')
  delete Component.options._Ctor
}
